var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectActivityAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "myMask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 46,
    height: 42,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 10,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#myMask)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.286 7L10.286 28M0 17.5L30.857 17.5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.857,
    height: 28,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7L30.857 7"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(36 32)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4,
    x2: 4,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: -4,
    y2: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectActivityAdd);
export default __webpack_public_path__ + "static/media/project-activity-add.8a3f2ac03c2fb77bf2cbae62a03579f6.svg";
export { ForwardRef as ReactComponent };